// extracted by mini-css-extract-plugin
module.exports = {"outer":"outer___2IlJN","message":"message___2lvBG","success":"success___3DBgi","error":"error___2fyqf","action":"action___1qvww","float":"float___1IE20"};